import React from 'react';
import { Outlet } from 'react-router-dom';
import { ApHeaderBar } from '@alixpartners/ui-components';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';

import { MainHeaderRightMenu } from '../../components/MainHeaderRightMenu';
import brandPlatformsLogo from '../../assets/images/brand-platforms-logo.svg';
import { Container, Logo, LogoWrapper } from './ReportManagerContainer.styles';

export const ReportManagerContainer = () => {
  return (
    <ApAuthenticationContextConsumer>
      {({ logout, user }) => {
        return (
          <>
            <ApHeaderBar
              logo={
                <LogoWrapper>
                  <Logo src={brandPlatformsLogo} alt="" />
                  Working Capital
                </LogoWrapper>
              }
              rightMenu={() => (
                <MainHeaderRightMenu
                  onLogout={logout}
                  userName={user?.profile?.name}
                />
              )}
            />
            <Container>
              <Outlet />
            </Container>
          </>
        );
      }}
    </ApAuthenticationContextConsumer>
  );
};
